import { Observable, asyncScheduler } from "rxjs";
import { map, subscribeOn } from "rxjs/operators";
import { compareVersion } from "@zyzgroup/core-common";
import { injectStyle } from "./useStyle";
import { useResize$ } from "./useResize";
import { isIOS, getOperatingSystemVersion } from "../env";

let isInjected = false;
function inject() {
  if (isInjected) {
    return;
  }
  isInjected = true;
  // <meta name="viewport" content="viewport-fit=cover" />
  // iPhoneX 可能有问题
  // 注意注入时：--xxx:后面不要有空格
  // if (isIOS() && compareVersion(getOperatingSystemVersion(), "11.2") < 0) {
  //   // iOS < 11.2
  //   injectStyle(`
  //     :root {
  //       --sat:constant(safe-area-inset-top, 0px);
  //       --sar:constant(safe-area-inset-right, 0px);
  //       --sab:constant(safe-area-inset-bottom, 0px);
  //       --sal:constant(safe-area-inset-left, 0px);
  //     }
  //     :host {
  //       --sat:constant(safe-area-inset-top, 0px);
  //       --sar:constant(safe-area-inset-right, 0px);
  //       --sab:constant(safe-area-inset-bottom, 0px);
  //       --sal:constant(safe-area-inset-left, 0px);
  //     }
  //   `);
  // } else {
  // iOS > 11.2
  injectStyle(`
    :root {
      --sat:env(safe-area-inset-top, 0px);
      --sar:env(safe-area-inset-right, 0px);
      --sab:env(safe-area-inset-bottom, 0px);
      --sal:env(safe-area-inset-left, 0px);
    }
    :host {
      --sat:env(safe-area-inset-top, 0px);
      --sar:env(safe-area-inset-right, 0px);
      --sab:env(safe-area-inset-bottom, 0px);
      --sal:env(safe-area-inset-left, 0px);
    }
  `);
  // }
}

inject();

export function useSafeArea$(): Observable<{
  bottom: string;
  top: string;
  right: string;
  left: string;
}> {
  return useResize$(document.documentElement).pipe(
    subscribeOn(asyncScheduler), // next tick
    map(() => {
      const declaration = getComputedStyle(document.documentElement);
      return {
        bottom: declaration.getPropertyValue("--sab"),
        top: declaration.getPropertyValue("--sat"),
        right: declaration.getPropertyValue("--sar"),
        left: declaration.getPropertyValue("--sal")
      };
    })
  );
}
